<template>
  <div class="vx-row">
    <vs-popup class="modern-survey-popup" :title="$t('addcompany.lbl4')" :active.sync="popupActivo4">
      
      <!-- Condition 1: Survey available and not overdue -->
      <div class="w-full p-2 text-left" v-if="skillsCount > 0 && motivationSurveyDate === null">
        <div class="w-full">
          <div>
            <div v-if="competencyProgressStep === 0">
              <div class="mb-6">
                <!-- Modern, left-aligned typography -->
                <h4 class="text-lg text-gray-600 mb-1 font-medium">{{ $t("competencyProgress.cp1") }}</h4>
                <h2 class="text-2xl font-bold text-primary mb-3">'{{$t(skillName)}}'</h2>
                <p class="text-base text-gray-700 leading-relaxed">{{ $t("competencyProgress.cp11") }}</p>
              </div>

              <!-- Buttons side-by-side layout -->
              <div class="flex flex-col sm:flex-row gap-4 mt-6">
                <vs-button class="flex-1 font-semibold" size="large" color="primary" type="filled" @click="skipTrue">
                  {{ $t("competencyProgress.cp2") }}
                </vs-button>
                <vs-button class="flex-1 font-semibold" size="large" color="danger" type="border" @click="skipFalse">
                  {{ $t("competencyProgress.cp3") }}
                </vs-button>
              </div>
            </div>

            <div v-if="this.$store.state.competencyProgress.skip === false" class="mt-4">
              <div v-for="i in 3" :key="i">
                <Question v-if="competencyProgressStep === i" :statement="progressStatements[i - 1]" :q="i - 1" />
              </div>
            </div>
          </div>
          <Result v-if="submit === true" :progress="progress" :practice="practice" :relevancy="relevancy" />
          
          <!-- Next / Save Buttons -->
          <div v-if="competencyProgressStep > 0" class="flex justify-end mt-6">
            <vs-button v-if="competencyProgressStep < 3" color="primary" type="filled" :disabled="disabledNextButton === false" @click="checkNext">
              {{ $t("competencyProgress.cp4") }}
            </vs-button>
            <vs-button v-else-if="competencyProgressStep === 3" color="primary" type="filled" @click="saveCompetencyProgress">
              {{ $t("competencyProgress.cp5") }}
            </vs-button>
          </div>
        </div>
      </div>

      <!-- Condition 2: Survey Status 1 -->
      <div class="w-full p-2 text-center" v-else-if="motivationSurveyDate && motivationSurveyStatus === 1">
        <h2 class="text-2xl font-bold text-gray-800 mt-4">{{ $t("competencyProgress.cp12") }}</h2>
      </div>

      <!-- Condition 3: Survey Overdue -->
      <div class="w-full p-2 text-left" v-else-if="motivationSurveyDate && motivationSurveyStatus === 2">
        <div class="w-full">
          <div>
            <div v-if="competencyProgressStep === 0">
              <div class="mb-6">
                <!-- Modern, left-aligned typography with overdue warning -->
                <h4 class="text-lg text-gray-600 mb-1 font-medium">{{ $t("competencyProgress.cp1") }}</h4>
                <h2 class="text-2xl font-bold text-primary mb-2">'{{$t(skillName)}}'</h2>
                
                <div class="bg-red-100 text-danger px-4 py-2 rounded mb-3 inline-block font-semibold text-sm">
                  {{ $t("competencyProgress.cp9") }} {{motivationOverdueCounter}} {{ $t("competencyProgress.cp10") }}
                </div>
                
                <p class="text-base text-gray-700 leading-relaxed">{{ $t("competencyProgress.cp11") }}</p>
              </div>

              <!-- Buttons side-by-side layout -->
              <div class="flex flex-col sm:flex-row gap-4 mt-6">
                <vs-button class="flex-1 font-semibold" size="large" color="primary" type="filled" @click="skipTrue">
                  {{ $t("competencyProgress.cp2") }}
                </vs-button>
                <vs-button class="flex-1 font-semibold" size="large" color="danger" type="border" @click="skipFalse">
                  {{ $t("competencyProgress.cp3") }}
                </vs-button>
              </div>
            </div>

            <div v-if="this.$store.state.competencyProgress.skip === false" class="mt-4">
              <div v-for="i in 3" :key="i">
                <Question v-if="competencyProgressStep === i" :statement="progressStatements[i - 1]" :q="i - 1" />
              </div>
            </div>
          </div>
          <Result v-if="submit === true" :progress="progress" :practice="practice" :relevancy="relevancy" />
          
          <!-- Next / Save Buttons -->
          <div v-if="competencyProgressStep > 0" class="flex justify-end mt-6">
            <vs-button v-if="competencyProgressStep < 3" color="primary" type="filled" :disabled="disabledNextButton === false" @click="checkNext">
              {{ $t("competencyProgress.cp4") }}
            </vs-button>
            <vs-button v-else-if="competencyProgressStep === 3" color="primary" type="filled" @click="saveCompetencyProgress">
              {{ $t("competencyProgress.cp5") }}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <div v-if="competencyProgress.total === 0" class="vx-card w-full no-box-shadow overflow-hidden mb-base">
      <!---->
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div>
          <div
            class="con-vs-avatar mx-auto my-6 block 80px"
            style="width: 250px; height: 200px; background: white/*rgb(195, 195, 195)*/;"
          >
            <!---->
            <div class="">
              <img
                src="@/assets/Illustrations/Ill_Skill Details_Progress.svg"
                alt=""
                style="color: grey;"
              />
            </div>
          </div>
          <div class="p-6 text-center">
            <!--<span
              class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
              style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
            >
              <img src="@/assets/Illustrations/Ill_Skill Details_Progress.svg" alt="attribute" class="skill-icon" />
            </span>-->
            <div class="truncate t-sd mb-2">
              <h5 class="mb-2" style="color: #079E9A;">
                {{ $t("skillDetails.progress.p1") }}
              </h5>
              <span>{{ $t("skillDetails.progress.p2") }}</span>
            </div>
            <vs-button v-if="progressStatus !== 'complete' && userType === 'trainee'" @click="addProgress">{{ $t("skillDetails.progress.p3") }}</vs-button>
           <vs-button v-if="progressStatus !== 'complete' && userType === 'coach'" @click="addProgress">{{ $t("skillDetails.progress.p3") }}</vs-button>
          </div>
          <!---->
        </div>
        <!----><!---->
      </div>
    </div>
    <div v-else class="vx-card w-full no-box-shadow overflow-hidden mb-base">
      <!---->
      <div class="vx-card__collapsible-content vs-con-loading__container p-2">
        <div class="p-6">
          <h5>{{ $t("skillDetails.progress.p4") }}</h5>
        </div>

        <div v-if="latestProgress !== null && latestPractice !== null && latestRelevancy !== null" class="mt-3 mb-base">
          <ProgressMeasureChart :progress="latestProgress" :practice="latestPractice" :relevancy="latestRelevancy" />
        </div>
        <div class="p-6 text-center">
          <vs-button v-if="progressStatus !== 'complete' && userType === 'trainee'" @click="addProgress">{{ $t("skillDetails.progress.p3") }}</vs-button>
      <vs-button v-if="progressStatus !== 'complete' &&  userType === 'coach' && terminology==2" @click="addProgress">{{ $t("skillDetails.progress.p3") }}</vs-button>
        </div>
        <div class="p-6">
          <h5>{{ $t("skillDetails.progress.p5") }}</h5>
        </div>
        <div v-for="pmr in competencyProgress" :key="pmr.id" class="mb-base">
          <span style="font-size: 10px; color: #9D9D9D;" class="ml-1">{{ $t("skillDetails.progress.p6") }}: {{formatDate(pmr.createdAt)}}</span>
          <ProgressMeasureHorizontal :progress="pmr.progress" :practice="pmr.practice" :relevancy="pmr.relevancy" />
        </div>
        <!----><!---->
      </div>
    </div>
  </div>
</template>

<script>
import dpmData from "@/i18n/i18n-en-Data-DPM.js";           
import deepData from "@/i18n/i18n-en-deep-Data.js";       
import pciData from "@/i18n/i18n-en-pci-Data-Coach.js";         
import peopletreeData from "@/i18n/i18n-en-peopletree-Data.js";
import defaultData from "@/i18n/i18n-en-Data.js";

import ProgressMeasureChart from "./competency-progress/ProgressMeasureChart";
import ProgressMeasureHorizontal from './competency-progress/ProgressMeasureHorizontal'
import Result from './competency-progress/Result'
import NoteToCoach from './competency-progress/NoteToCoach'
import QuestionZero from './competency-progress/QuestionZero'
import Question from './competency-progress/Question'
export default {
  name: "Progress",
  props: ["progressStatus","terminology"],
  data() {
    return {
      userType: this.$store.state.AppActiveUser.userType,
      competencyProgress: {},
      latestProgress: null,
      latestPractice: null,
      CCD: this.$t("addNewSkill.data"),
      skillName:null,
      latestRelevancy: null,
      popupActivo4:false,
      popupActivo5:false,
      skillsCount:null,
      SkillsProgressCount:null,
      motivationSurveyDate:"",
      motivationSurveyStatus:'',
      motivationOverdueCounter:'',
      submit: false,
      competencyProgressStep: 0,
      competencyId: "",
      characteristicId: "",
      competencyNum: "",
      progressStatements: [
        this.$t("competencyProgress.cp6"),
        this.$t("competencyProgress.cp7"),
        this.$t("competencyProgress.cp8")
      ],
      numOfStatements: "",
      traineeCompetenciesId: "",
      motivationSurveyDays:null,
      progress: 0,
      practice: 0,
      relevancy: 0,
      skip: true,
      terminology:null
    }
  },
  components: {
    ProgressMeasureHorizontal, ProgressMeasureChart,
    Result,
    NoteToCoach,
    QuestionZero,
    Question
  },
  watch: {
    skillName(newValue, oldValue) {
      console.log(`👀 skillName updated in view: changed from "${oldValue}" to "${newValue}"`);
    }
  },
  methods: {
    _searchInDataset(dataset, targetId) {
      if (!dataset || !targetId) return null;
      let parts = targetId.split("-");
      for (let key in dataset) {
        if (dataset[key] && dataset[key].competencies) {
          let comps = dataset[key].competencies;
          if (Array.isArray(comps)) {
            let found = comps.find(c => c.id === targetId);
            if (found) return found;
          } else {
            for (let k in comps) {
              if (comps[k] && comps[k].id === targetId) return comps[k];
              if (key === parts[0] && k === parts[1]) return comps[k];
            }
          }
        }
      }
      return null;
    },
    getSkillData(targetId, competencyRecord) {
      if (!targetId) return null;

      console.log("========== 🔍 SKILL RESOLUTION LOGS ==========");
      console.log("1. Target ID to find:", targetId);
      console.log("2. Raw Competency Record from DB:", competencyRecord);

      // (Optional) If your database saves the framework name (e.g., 'pci', 'founder') in the record:
      let framework = null;
      if (competencyRecord) {
        framework = competencyRecord.framework || competencyRecord.category || null;
      }
      console.log("3. Detected Framework Context from DB:", framework);

      let found = null;

      // Search all files to see where this ID actually exists
      const sources = [
        { name: "PCI (Founder)", data: pciData },
        { name: "DEEP (Ecosystem)", data: deepData },
        { name: "PeopleTree (Performance)", data: peopletreeData },
        { name: "DPM (Behavior)", data: dpmData },
        { name: "Base/Default", data: defaultData }
      ];

      let possibleMatches = [];
      
      for (let source of sources) {
        // Ensure data exists before searching
        if (source.data && source.data.addNewSkill && source.data.addNewSkill.data) {
          let match = this._searchInDataset(source.data.addNewSkill.data, targetId);
          if (match) {
            possibleMatches.push({ source: source.name, comp: match.comp || match.name, obj: match });
          }
        }
      }

      // Handle the results
      if (possibleMatches.length > 1) {
        console.warn("🚨 4. ID COLLISION DETECTED! This ID exists in multiple frameworks:", possibleMatches);
        
        // Since you are in PCI looking for Cross the Chasm, prioritize the PCI match
        let pciMatch = possibleMatches.find(m => m.source === "PCI (Founder)");
        if (pciMatch) {
            console.log("➡️ Auto-selecting PCI match as fallback:", pciMatch.comp);
            found = pciMatch.obj;
        } else {
            // Otherwise just take the first one found
            found = possibleMatches[0].obj;
        }
      } else if (possibleMatches.length === 1) {
        console.log(`✅ 4. Single match found in [${possibleMatches[0].source}]:`, possibleMatches[0].comp);
        found = possibleMatches[0].obj;
      } else {
        console.error("❌ 4. SKILL NOT FOUND IN ANY LOCAL DATASET");
      }

      console.log("========== END SKILL RESOLUTION LOGS ==========");
      return found;
    },
    skipTrue() {
      this.$store.dispatch("competencyProgress/skipTrue").catch(err => {console.log(err)})
      this.saveCompetencyProgress();
    },
    skipFalse() {
      this.$store.dispatch("competencyProgress/skipFalse").catch(err => {console.log(err)})
      this.competencyProgressStep = this.competencyProgressStep + 1;
    },
    checkNext() {
      if (this.$store.state.competencyProgress.skip === false) {
        this.competencyProgressStep = this.competencyProgressStep + 1;
      } else {
        this.saveCompetencyProgress();
      }
    },
    disabledNextButton() {
      return false;
    },
    saveCompetencyProgress() {
      let por = {};
      const id = this.$route.params.traineeCompetenciesId;
      const query = { id };
      this.$store
        .dispatch("addSkill/findCompetency", { query })
        .then(res => {
          let traineeCompetenciesId = [];
          for (let k = 0; k <res.data.length; k++) {
            traineeCompetenciesId.push(res.data[k].id);
          }
          for(let i = 0; i <traineeCompetenciesId.length; i++){
            let dt =new Date();
            let motivationSurveyDate = new Date(dt.setDate(dt.getDate() + this.motivationSurveyDays));
            const updateData = {
              id:traineeCompetenciesId[i],
              motivationSurveyDate: motivationSurveyDate
            };
            this.$store
              .dispatch("endorsementInvite/markGoalComplete", updateData)
              .then(res => {}).catch();
          }
        })
      if(this.$store.state.competencyProgress.skip === false) {
        por = {
          progress: this.$store.state.competencyProgress.progress,
          practice: this.$store.state.competencyProgress.practice,
          relevancy: this.$store.state.competencyProgress.relevancy,
          traineeCompetenciesId: this.$route.params.traineeCompetenciesId
        };
      } else {
        por = {
          progress: 100,
          practice: 100,
          relevancy: 100,
          traineeCompetenciesId: this.$route.params.traineeCompetenciesId
        };
      }

      this.$store
        .dispatch("competencyProgress/saveProgress", por)
        .then(res => {
          this.progress = por.progress;
          this.practice = por.practice;
          this.relevancy = por.relevancy;
          this.submit = true;
          this.popupActivo5=false;
          window.location.reload();
        })
        .catch(err => {
          console.log("progress could not be saved", err);
        });
    },
    formatDate(createdAt) {
      let date = new Date(createdAt)
      date = `${date.getDate()  }-${  date.getMonth()+1 }-${  date.getFullYear()}`;
      return date;
    },
    addProgress() {
      this.popupActivo4= true;
      this.popupActivo5=true;
      let data= JSON.parse(localStorage.getItem('userInfo'));
      const query = { traineeId: data.usersId };
      this.$store
        .dispatch("coachingExperience/fetchCoach", { query })
        .then(res => {
          this.motivationSurveyDays=res.data[0].userData[0].company[0]['coachingSurveyDays'];
          this.traineeCoachId = res.data[0].id;
        })
        .catch(err => {
          console.log("coach not found", err);
        });
      const id = this.$route.params.traineeCompetenciesId
      this.$store.dispatch('addSkill/findCompetency', {query: {id:id,usersId: data.usersId,progressStatus:'in_progress'}})
        .then(res => {
          if(res.data.length===0){
            this.skillsCount=0;
          }else{
            if(res.data[0].motivationSurveyDate===null && res.data[0].progressStatus==='in_progress'){
              this.motivationSurveyDate=res.data[0].motivationSurveyDate;
            }else if (res.data[0].motivationSurveyDate !=null && res.data[0].progressStatus==='in_progress'){
              if(new Date() < new  Date(res.data[0].motivationSurveyDate)){
                this.motivationSurveyDate=res.data[0].motivationSurveyDate;
                this.motivationSurveyStatus=1;
              }else if(new Date() > new Date(res.data[0].motivationSurveyDate)){
                this.motivationSurveyDate=res.data[0].motivationSurveyDate;
                const date1 = new Date(this.motivationSurveyDate);
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                this.motivationOverdueCounter=diffDays;
                this.motivationSurveyStatus=2;
              }
            }
            this.skillsCount=res.data.length;
          }
        })
        .catch(err => {
          console.log("coach not found", err);
        });
      const userId=this.$store.state.AppActiveUser.usersId;
      this.$store
        .dispatch("users/find", { query:{id :userId} })
        .then(res1 => {
          this.motivationSurveyDays=res1.data[0]['company'][0]['motivationSurveyDays']
        }).catch();
    }
  },
  mounted() {
    this.terminology=this.terminology;
  },
  created() {
    this.$store.dispatch("competencyProgress/destroyAllState").catch(err => {console.log("could not destroy state", err)});

    this.traineeCompetenciesId = this.$route.params.traineeCompetenciesId;

    if (
      this.competencyProgressStep === 1 &&
      this.$store.state.competencyProgress.skip === true
    ) {
      this.saveCompetencyProgress();
    }
    const id = this.$route.params.traineeCompetenciesId
    const query = {
      traineeCompetenciesId: id,
      $sort: { createdAt: -1 }
    }

    this.$store.dispatch("trainee-competencies/find", {query:{ id: id}}).then(res => {
      const dbRecord = res.data[0];
      
      // Pass both the ID and the full record to our new function
      let foundCompetency = this.getSkillData(dbRecord['competencyId'], dbRecord);
      
      if (foundCompetency) {
        this.skillName = foundCompetency.comp || foundCompetency.name || dbRecord.skill_name || "Custom Skill";
      } else {
        this.skillName = dbRecord.skill_name || "Custom Skill";
      }
      
      console.log("🎯 FINAL RESOLVED SKILL NAME FOR UI:", this.skillName);
    }).catch(err => {
      console.log("error fetching competency progress", err)
    })

    this.$store.dispatch("competencyProgress/fetchCompetencyProgress", {query}).then(res => {
      this.competencyProgress = res
      if(res.total > 0) {
        this.latestRelevancy = res.data[0].relevancy
        this.latestProgress = res.data[0].progress
        this.latestPractice = res.data[0].practice
        this.competencyProgress = res.data
      }
    }).catch(err => {
      console.log("error fetching competency progress", err)
    })
  }
};
</script>

<style scoped>
.no-box-shadow {
  box-shadow: none !important;
}
.t-sd {
  white-space: normal! important;
}
.skill-icon {
  width: 25px;
  height: 25px;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
@media (max-width: 767px) {
  .footer-next {
    position: fixed;
    bottom: 0;
    /*width: 100%;*/
    width: 100vw;
    left: calc(-50vw + 50%);
  }
}

.vx-card-next {
  margin-top: 2rem;
  /*border-radius: 0;*/
  box-shadow: none;
  -webkit-box-shadow: none;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
.modern-survey-popup ::v-deep .vs-popup {
  width: 550px !important;
  max-width: 95vw;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

/* Make the header look cleaner */
.modern-survey-popup ::v-deep .vs-popup--header {
  border-bottom: 1px solid #edf2f7;
  padding: 1.25rem 1.5rem;
  background-color: #fafafa;
  border-radius: 12px 12px 0 0;
}

/* Padding for the inside content */
.modern-survey-popup ::v-deep .vs-popup--content {
  padding: 2rem 1.5rem;
}

/* Flexbox utility for button spacing if Tailwind isn't active */
.gap-4 {
  gap: 1rem;
}
</style>
